/** Дебаунс запроса подсказок регионов (как в DIY-модалке брокера). */
export const REGION_SUGGEST_DEBOUNCE_MS = 300;

/** Минимальная длина строки до запроса к geo find-search-catalog-items. */
export const MIN_REGION_SUGGEST_CHARS = 3;

/** Текст тоста при сетевой ошибке или неуспешном ответе geo API при поиске региона. */
export const REGION_SUGGEST_API_ERROR_TOAST_TEXT = 'Что-то пошло не так. Попробуйте ещё раз.';
